import { ArticlePageProps } from "/Models/Generated/ArticlePageProps";
import "./ArticlePage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import {
  HeroWithImage,
  ContentArea,
  GridRow,
  MainIntro,
  GridPresetSidebar,
  GridPresetMainContent,
  MetaInfoBlock,
} from "/App.Components";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";

const ArticlePage = ({
  pageHeader,
  mainIntro,
  mainIntroPropertyName,
  mainBody,
  metaInfoBlock,
  sidebar,
  bottomContentArea,
}: ArticlePageProps) => (
  <div className="article-page-norad">
    {pageHeader && <HeroWithImage {...pageHeader} />}

    {(mainBody || mainIntro || sidebar) && (
      <div className="article-page-norad__main-body">
        <GridRow>
          <GridPresetMainContent>
            {(mainIntro || mainIntroPropertyName) && (
              <MainIntro {...{ mainIntro, mainIntroPropertyName }} />
            )}
            {mainBody && (
              <ContentArea
                {...mainBody}
                contentAreaType={ContentAreaType.HalfWidth}
              />
            )}
          </GridPresetMainContent>
          <GridPresetSidebar>
            <aside>
              <ContentArea
                {...sidebar}
                contentAreaType={ContentAreaType.OneThird}
                margin={ContentAreaItemMargin.Sidebar}
              />
            </aside>
          </GridPresetSidebar>
        </GridRow>
      </div>
    )}
    {metaInfoBlock?.author?.fullName && (
      <div className="article-page-norad__meta-info-block-container">
        <GridRow>
          <GridPresetMainContent>
            <MetaInfoBlock {...metaInfoBlock} showPageMetadata={false} />
          </GridPresetMainContent>
        </GridRow>
      </div>
    )}
    <ContentArea
      {...bottomContentArea}
      contentAreaType={ContentAreaType.FullWidth}
    />
  </div>
);

export default ArticlePage;
